import React from 'react';
import { getSafe } from '../../helpers/utils';
import FlightPreview from './FlightPreview';
import CarPreview from './CarPreview';
import TrainPreview from './TrainPreview';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import BooleanToString from '../../helpers/BooleanToString';

export default function Travel ({ guest }) {
    const event = guest?.invitation?.event;
	return (
		<div>

            <div className="row">
                <div className="col-lg-4 col-12">
                    <label>
                        <TextTranslate name="travel-switch-circuit-only" fallback="Will you be joining the experience at the circuit only?" textOnly/>
                    </label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>
                        <BooleanToString condition={guest.requirement.travel_circuit_only}/>
                    </p>
                </div>
            </div>
            <hr/>
            {event.ground_transfer ? (
                <>
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <label>
                                <TextTranslate name="travel-switch-ground-transfers" fallback="Will you require ground transfers?" textOnly/>
                            </label>
                        </div>
                        <div className="col-lg-8 col-12">
                            <p>
                                <BooleanToString condition={guest.requirement.travel_ground_transfers}/>
                            </p>
                        </div>
                    </div>
                    <hr/>
                </>
            ) : null}
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label>
                        <TextTranslate name="travel-switch-more-information" fallback="Do you have further information to share?" textOnly/>
                    </label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>
                        <BooleanToString condition={guest.requirement.travel_enabled}/>
                    </p>
                </div>
            </div>


            {guest.requirement.travel_enabled && (
                <>
                    <hr/>

                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <label><TextTranslate name="travel-transport-method" fallback="Transport Method" textOnly/></label>
                        </div>
                        <div className="col-lg-8 col-12">
                            <p className="text-capitalize">
                                <TextTranslate
                                    name={`travel-${getSafe(() => guest.requirement.travel_method, 'n/a')?.toLowerCase()}`}
                                    fallback={guest?.requirement?.travel_method || "No transport method."}
                                    textOnly
                                />
                            </p>
                        </div>
                    </div>
                    <hr />
                    { guest.requirement.travel_method === 'flight' && <FlightPreview guest={guest} /> }
                    { guest.requirement.travel_method === 'car' && <CarPreview guest={guest} /> }
                    { guest.requirement.travel_method === 'train' && <TrainPreview guest={guest} /> }
                </>
            )}
		</div>
	)
}
